module.exports = __webpack_public_path__ + "img/user.d641947d.svg";